@let pageState = $pageState(); @if(pageState){
<custom-dot-cms-blog-page [post]="urlContentMap()" />
}
